import React from 'react';
import FilerobotImageEditor, { TABS, TOOLS } from 'react-filerobot-image-editor';
import './PhotoMarkup.scss';

// Turns the editor's base64 result into a File, so it uploads like a newly added photo
const base64ToFile = (base64, fileName, mimeType) => {
  const data = atob(base64.split(',')[1] || '');
  const bytes = new Uint8Array(data.length);
  for (let i = 0; i < data.length; i++) {
    bytes[i] = data.charCodeAt(i);
  }
  return new File([bytes], fileName, { type: mimeType });
};

// Full-screen photo editor: rectangles, arrows, pen, text, crop / rotate
const PhotoMarkupEditor = ({ source, fileName, onSave, onClose }) => {
  const baseName = (fileName || 'photo').replace(/\.[^.]+$/, '');

  if (!source) {
    return (
      <div className="photo-markup-overlay">
        <div className="photo-markup-loading">Opening photo…</div>
      </div>
    );
  }

  return (
    <div className="photo-markup-overlay">
      <div className="photo-markup-box">
        <FilerobotImageEditor
          source={source}
          tabsIds={[TABS.ANNOTATE, TABS.ADJUST]}
          defaultTabId={TABS.ANNOTATE}
          defaultToolId={TOOLS.RECT}
          annotationsCommon={{ fill: '#00000000', stroke: '#ff0000', strokeWidth: 6 }}
          Text={{ text: 'Text', fill: '#ff0000', fontSize: 48 }}
          Pen={{ stroke: '#ff0000', strokeWidth: 6 }}
          Arrow={{ stroke: '#ff0000', fill: '#ff0000', strokeWidth: 6 }}
          defaultSavedImageName={baseName}
          defaultSavedImageType="jpeg"
          defaultSavedImageQuality={0.92}
          // Pixel ratio is applied to the on-screen editor size; 4 keeps the saved photo at full sharpness
          savingPixelRatio={4}
          previewPixelRatio={window.devicePixelRatio || 1}
          // Save straight away, without the file name / type popup
          onBeforeSave={() => false}
          onSave={(edited) => {
            const mimeType = edited.mimeType || 'image/jpeg';
            const extension = edited.extension || 'jpeg';
            onSave(base64ToFile(edited.imageBase64, `${baseName}-edited.${extension}`, mimeType));
          }}
          onClose={onClose}
        />
      </div>
    </div>
  );
};

export default PhotoMarkupEditor;
